$(document).ready(function(){
  $('.view-style-icon').on('click', function() {
      $('.view-style-icon').removeClass('selected');
      $(this).addClass('selected');
  
      let isGrid = $(this).hasClass('icon-grid');
  
      $('#product-grid').toggleClass('grid product-grid', isGrid)
                        .toggleClass('list-view product-list', !isGrid);
  
      $('#product-grid li').toggleClass('grid__item', isGrid)
                                       .toggleClass('list__item', !isGrid);
  });
});